<template>
  <b-row>
    <b-col md="4">
      <label>País</label>
    </b-col>
    <b-col md="8">
      <select-box
        v-show="paises.length > 1"
        :options="paisesCombo"
        :disabled="disabled"
        @input="cambiarPais"
        placeholder="Seleccione un país"
      />
      <span v-show="paises.length <= 1">
        <b-form-input readonly :value="pais.nombre" />
      </span>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "pais", "paises"]),
    paisesCombo() {
      return this.paises.map((x) => {
        return {
          id: x.id,
          text: x.nombre,
        };
      });
    },
  },
  methods: {
    ...mapActions(useOfertaFormStore, ["cambiarPais"]),
  },
};
</script>
